import i18n from "i18next";
import { frFR, enUS } from "@mui/x-data-grid/locales";
import CanadaFlag from "../assets/img/flags/canada-512.png";
import USAFlag from "../assets/img/flags/unitedStates-512.png";
import { downloadBulletinPDF } from "../service/SalesNews";
const ExcelJS = require("exceljs");
import { saveAs } from "file-saver";
import { signOut } from "aws-amplify/auth";
import { LOGOUT_USER } from "../store/reducer/userReducer";
import { logoutCookies } from "../service/common";
import { ALLOWED_INDIRECT_ROLES, USERTYPES } from "./constants";
import DOMPurify from "dompurify";

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
	const links = node?.querySelectorAll("a");
	links.forEach((link) => {
		link.setAttribute("target", "_blank");
		link.setAttribute("rel", "noopener noreferrer");
	});
});

export const removeHash = (event) => {
	event.preventDefault();
};

export const languageOptions = {
	"en-US": {
		lang: "US",
		country: "us",
		countryCode: "us",
		languageCode: "en-us",
		label: "US English",
		flag: USAFlag,
		salesOrg: "US00",
		spokenLanguage: "EN"
	},
	// "es_US": {//removed as per business decision
	//   lang: "ES",
	//   country: "us",
	//   countryCode: "us",
	//   languageCode: "es-US",
	//   label: "US Spanish",
	//   flag: USAFlag,
	// },
	"en-CA": {
		lang: "CAN",
		country: "ca",
		countryCode: "ca",
		languageCode: "en-ca",
		label: "CAN English",
		flag: CanadaFlag,
		salesOrg: "CA00",
		spokenLanguage: "EN"
	},
	"fr-CA": {
		lang: "FR",
		country: "ca",
		countryCode: "ca",
		languageCode: "fr-ca",
		label: "CAN French",
		flag: CanadaFlag,
		salesOrg: "CA00",
		spokenLanguage: "FR"
	},
};

export async function downloadZippedPDFs(bulletin_nos) {
	const pdfUrls = await downloadBulletinPDF(bulletin_nos);
	console.log("Download pdfs", pdfUrls);
	const link = document.createElement("a");
	link.href = pdfUrls;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export const generateMonthYearOptions = () => {
	const options = [];
	const now = new Date();
	for (let i = 0; i < 12; i++) {
		const monthYear = new Date(now.getFullYear(), now.getMonth() - i, 1);
		const month = monthYear.toLocaleString("default", { month: "short" });
		const year = monthYear.getFullYear();
		options.push(`${month}-${year}`);
	}
	return options;
};

export function convertLngToUnderScore(lng) {
	return lng.replace("-", "_");
}
export const titleCase = (str) => str[0].toUpperCase() + str.slice(1);
export function camilCaseToSentence(str) {
	return str
		.replace(/([a-z])([A-Z])/g, "$1 $2")
		.toLowerCase()
		.replace(/(^|\s)\S/g, (match) => match.toUpperCase());
}
export async function createExcel(cols, data) {
	const workbook = new ExcelJS.Workbook();
	workbook.creator = "Dealer Source";
	workbook.lastModifiedBy = "Dealer Source";
	const sheet = workbook.addWorksheet("Sheet 1");
	let finalCols = [];
	cols.forEach((col) => {
		if ((col.headerName != "Checkbox selection") && (col.headerName != "Sélection")) {
			finalCols.push({ header: col.headerName, key: col.field });
			if (col?.valueFormatter) {
				data = data.map((row) => {
					let toFormat = row[col.field];
					toFormat = col.valueFormatter(toFormat);
					return { ...row, [col.field]: toFormat };
				});
			}
		}
	});
	sheet.columns = finalCols;
	sheet.addRows(data);
	const buffer = await workbook.xlsx.writeBuffer();
	const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
	saveAs(blob, "search-results.xlsx");
}

export function hasAccess(permissions, userRoles, userCustomerGroup, activeSalesOrg, activeUserType, acutalUserIsInternal = false) {
	const isIndirect = userRoles.some((role) => ALLOWED_INDIRECT_ROLES.includes(role)) && activeUserType.toUpperCase() === "B2B";
	const isActiveInternal = activeUserType.toUpperCase() === USERTYPES.INTERNAL;
	const hasRolePermission = permissions.roles.length === 0 || permissions.roles.some((role) => userRoles.includes(role));
	const hasGroupPermission = permissions.customerGroups.length === 0 || permissions.customerGroups.some((custGr) => userCustomerGroup === custGr);
	const hasLangPermission = !permissions.lang || permissions.lang === i18n.language;
	const hasSalesOrgPermission = !permissions.salesOrg || 
		permissions?.salesOrg?.length === 0 || 
		permissions?.salesOrg?.includes(activeSalesOrg);

	if (permissions?.internalOnly) {
		if (acutalUserIsInternal) return hasRolePermission;
		return isActiveInternal && hasRolePermission;
	}
	if (isActiveInternal && permissions.internal) {
		return true && hasLangPermission;
	}
	if (isIndirect) {
		return hasRolePermission && hasLangPermission;
	}
	return hasRolePermission && hasGroupPermission && hasLangPermission && hasSalesOrgPermission;
}
export async function handleLogout(isInternal, setUserState, navigate, queryClient, cb) {
	try {
		if (isInternal) await logoutCookies();
	} catch (error) {
		console.log("Failed to Clear cookies");
	}
	await signOut();
	setUserState({
		type: LOGOUT_USER,
	});
	if (cb) cb();
	queryClient?.clear();
	navigate("/");
}
export function throttle(cb, ms) {
	let lastTime = 0;
	return () => {
		const now = Date.now();
		if (now - lastTime >= ms) {
			cb();
			lastTime = now;
		}
	};
}
export function sanitizeWithAnchor(dirtyHTML) {
	return DOMPurify.sanitize(dirtyHTML, { ADD_ATTR: ["target"] });
}
export function getTranslationForDataGrid(currentLng) {
	switch (currentLng) {
		case "fr-CA":
			return frFR.components.MuiDataGrid.defaultProps.localeText;

		default:
			return enUS.components.MuiDataGrid.defaultProps.localeText;
	}
}

export const MIN_TIMESTAMP = 0;                  // 1970-01-01T00:00:00Z in seconds
export const MAX_TIMESTAMP = 32503680000;        // 3000-01-01T00:00:00Z in seconds

export function isValidUnixMilliseconds(val) {
	return /^\d{13}$/.test(val);
}

export function isValidUnixSeconds(val) {
	const num = Number(val);
	return /^\d{10}$/.test(val) && num >= MIN_TIMESTAMP && num <= MAX_TIMESTAMP;
}

// Parse string as UTC date:
export function parseDateStringUTC(str) {
	// ISO date only (YYYY-MM-DD) -> UTC midnight
	if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
		const [year, month, day] = str.split('-').map(Number);
		return new Date(Date.UTC(year, month - 1, day));
	}

	// ISO datetime with space (YYYY-MM-DD HH:mm:ss) -> convert to ISO + Z
	if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(str)) {
		const iso = str.replace(' ', 'T') + 'Z';
		const d = new Date(iso);
		if (!isNaN(d)) return d;
	}

	// ISO datetime without timezone (YYYY-MM-DDTHH:mm:ss) -> treat as UTC by appending Z
	if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(str)) {
		const d = new Date(str + 'Z');
		if (!isNaN(d)) return d;
	}

	// Fallback: try normal Date parse (may interpret local timezone)
	const d = new Date(str);
	return isNaN(d) ? null : d;
}

export function normalizeDate(dateValue) {
	if (!dateValue) return null;

	if (dateValue instanceof Date) return isNaN(dateValue) ? null : dateValue;

	if (typeof dateValue === 'number') {
		const len = dateValue.toString().length;
		if (len === 13) return new Date(dateValue);
		if (len === 10) return new Date(dateValue * 1000);
		return null;
	}

	if (typeof dateValue === 'string') {
		const val = dateValue.trim();

		if (isValidUnixMilliseconds(val)) {
			const d = new Date(Number(val));
			return isNaN(d) ? null : d;
		}

		if (isValidUnixSeconds(val)) {
			const d = new Date(Number(val) * 1000);
			return isNaN(d) ? null : d;
		}

		return parseDateStringUTC(val);
	}

	return null;
}

export function formatDate(
	dateValue,
	locale = 'en-US',
	style = 'medium',
	timeZone = 'UTC'
) {
	if (!dateValue) return null;

	const date = normalizeDate(dateValue);
	if (!date) return 'Date not available';

	const formats = {
		short: { year: "2-digit", month: "numeric", day: "numeric", timeZone }, // (e.g., "8/18/25")
		medium: { year: "numeric", month: "long", day: "numeric", timeZone },  // (e.g., "August 18, 2025")
		long: { weekday: "long", year: "numeric", month: "long", day: "numeric", timeZone }, // (e.g., "Monday, August 18, 2025")
	};

	const options = formats[style] || formats.medium;

	return new Intl.DateTimeFormat(locale, options).format(date);
}

// Fire a GA4 event , then navigate
// Waits for the GA ready before pushing and redirecting only after Googleacknowledges the hit
// redirect when GTM confirms processing, and never traps the user (deadline).
export const trackThenRedirect = (pushToDL, eventName, params, isAllowToTrackAll, url, ceiling = 2000) => {
	let done = false;
	let obs = null;
	const go = () => {
		if (done) return;
		done = true;
		if (obs) obs.disconnect();
		window.location.href = url
	};

	// GTM blocked/absent -> analytics can never hold the PDF hostage
	if (!window.google_tag_manager) { go(); return; }

	const deadline = Date.now() + ceiling;

	// A G-XXXX key appears on google_tag_manager only when the destination has finished initializing
	const gaReady = () => Object.keys(window.google_tag_manager).some((k) => k.startsWith('G-'));

	const fire = () => {
		try {
			// gtag send /g/collect via fetch -> visible in Resource Timing = exact dispatch signal
			obs = new PerformanceObserver((list) => {
				if (list.getEntries().some((e) => e.name.includes('/g/collect'))) go();
			});
			obs.observe({ type: 'resource' });
		} catch (e) {
			/* older browser - callback/ceiling below cover it */
		}

		pushToDL(eventName, { ...params, eventCallback: () => setTimeout(go, 700), eventTimeout: 1000 }, isAllowToTrackAll);
	}

	const waitReady = () => {
		if (done) return;

		if (gaReady()) { fire(); return;}
		if (Date.now() > deadline) { go(); return; }
		setTimeout(waitReady, 50);
	};
	waitReady();
};

// Read a JWT payload without verifying - analytics gating only, backend still verifies.
export const decodeJwtPayload = (token) => {
	try {
		return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
	} catch (e) { return {}; }
}

export const getCleanURL = () => {
	const u = new URL(window.location.href);
	u.searchParams.delete('token');
	return u.toString();
}